'use strict';
//import $ from 'jquery';
//window.$ = window.jQuery = $;

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
// Variations that I tried - one at a time
require('materialize-css');
require('jquery-lazy');
require('slick-carousel');
require('sweetalert');
require('./contact');
require('./jquery.waypoints.min');
var contLogin,campo,emailRegex;

$(function($) {
    $("img.lazy").Lazy({
        chainable: false,
        threshold: 500,
        visibleOnly: false,
    });
});

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
        },0);
    }
    window.load = cargar();
    $('.sidenav').sidenav({
        edge: 'left'
    });
    $(".dropdown-trigger").dropdown({
        hover: false,
    });
    $('.modal').modal();
});

$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});

$('.clickAbout').click(function () {
    $('html, body').animate({
        scrollTop: $('#about').offset().top - 100
    }, 1000);
});
$('.clickContact').click(function () {
    $('html, body').animate({
        scrollTop: $('#contact').offset().top - 100
    }, 1000);
});
$('.clickServices').click(function () {
    $('html, body').animate({
        scrollTop: $('#services').offset().top - 100
    }, 1000);
});
$('.clickPaquets').click(function () {
    $('html, body').animate({
        scrollTop: $('#packages').offset().top - 100
    }, 1000);
});
$('.clickPlants').click(function () {
    $('html, body').animate({
        scrollTop: $('#plants').offset().top - 100
    }, 1000);
});


$(window).scroll(function() {
    if ($(window).width() > 991) {
        if ($(document).scrollTop() > 96) {
            $('.header').css('background', '#ffffff', '!important');
            $('.header').addClass('header-shadow');
            $('.header .brand-logo .desktop').attr('src', https + 'img/header/logoblack.png');
            $('.header .brand-logo .desktop').addClass('desktop_down');

            $('.header').css('height', '85px', '!important');
            $('.header').css('line-height', '85px', '!important');
            $('.header a').css('color', '#EA2621', '!important');
            $('.header .buton').css('margin', '11% 0%', '!important');
            $('.header .buton img').attr('src', https + 'img/header/logo_epayco.png');

        } else {
            if ($(document).scrollTop() >= 0 && $(document).scrollTop() <= 85) {
                $('.header').css('background', 'transparent', '!important');
                $('.header').removeClass('header-shadow');
                $('.header .brand-logo .desktop').attr('src', https + 'img/header/logowhite.png');
                $('.header .brand-logo .desktop').removeClass('desktop_down');

                $('.header').css('height', '150px', '!important');
                $('.header').css('line-height', '150px', '!important');
                $('.header a').css('color', '#ffffff', '!important');
                $('.header .buton').css('margin', '23% 0%', '!important');
                $('.header .buton img').attr('src', https + 'img/header/logo_epayco_white.png');
            }
        }
    }
});

$(document).ready(function () {
    $('#sliderBanner').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: 'easeOutElastic',
        fade: true,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        customPaging : function(slider, i) {
            return '<a><img src="'+https+'img/banner/dots.svg"/><img src="'+https+'img/banner/dot-active.svg" /</a>';
        },
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dotsClass: 'slick-dots',
                    customPaging: function (slider, i) {
                        //FYI just have a look at the object to find aviable information
                        //press f12 to access the console
                        //you could also debug or look in the source
                        console.log(slider);
                        var slideNumber = (i + 1),
                            totalSlides = slider.slideCount;
                        return '<a class="dot" role="button" title="' + slideNumber + ' of ' + totalSlides + '"><span class="string">·</span></a>';
                    }
                }
            }
        ]
    });

    $('#sliderBanner').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(".sectionBanner img").css('transition','transform 0s');
        $(".sectionBanner img").css('transform','scale(1.1)');
    });
    $('#sliderBanner').on('afterChange', function(event, slick, currentSlide, nextSlide){
        setTimeout(function () {
            $(".sectionBanner img").css('transition','transform 4s');
            $(".sectionBanner img").css('transform','scale(1)');
        },100);
    });

    $('#sliderServiceIcon').slick({
        dots: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    setTimeout(function () {
        var access_token = location.hash.split('=')[1];
        var URL_API_INSTAGRAM = "https://api.instagram.com/v1/users/"+instagram_id+"/media/recent/?count=15&access_token="+instagram_token+"&callback=?";
        $.getJSON(URL_API_INSTAGRAM,function(data) {
            var i = 1;
            $('.instragramImages').html("");
            $.each(data.data, function (item, value) {
                if (i <= 8) {
                    $('.instragramImages').append('' +
                        '<div class="">' +
                        '<a target="_blank" href="' + data.data[item].link + '">' +
                        '<div class="element">'+
                        '   <div class="containerInstagram">' +
                        '       <div class="img">'+
                        '           <img data-lazy="' + value.images.low_resolution.url + '" alt="">' +
                        '       </div>'+
                        '   </div>' +
                        '</div>'+
                        '</a>' +
                        '</div>');
                }
                i++;
            });
            $('#sliderInsta').slick({
                dots: false,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                adaptiveHeight: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 3000,
                pauseOnHover: false,
                pauseOnDotsHover: false,
                pauseOnFocus: false,
                prevArrow: $('.prev-slider-sliderIns'),
                nextArrow: $('.next-slider-sliderIns'),
                lazyLoad: 'ondemand',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    },100);

    /*
    $('#sliderGalery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        autoplay: false,
        autoplaySpeed: 0,
        asNavFor: '#sliderGalery_all',
        lazyLoad: 'ondemand',
    });

    $('#sliderGalery_all').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '#sliderGalery',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        lazyLoad: 'ondemand',
        vertical: true,
        verticalSwiping: true,
        prevArrow: $('.modalServices .sliderButtons .prev'),
        nextArrow: $('.modalServices .sliderButtons .next'),
    });

    $('#sliderGalery').on('afterChange', function(event, slick, currentSlide, nextSlide){
        $('#sliderGalery').slick('slickSetOption', 'autoplay', false, false);
        $('#sliderGalery').slick('slickSetOption', 'autoplaySpeed', 10000, 10000);
    });
     */
});


$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

$('.sectionServices .element').click(function () {
    //$('#sliderGalery').slick('slickSetOption', 'autoplay', true, true);
    $.ajax({
        url: https + "getGalery",
        method: "POST",
        data: {service_id:this.id,action:'getGalery'},
        success: function (data) {
            $('#modalServices .rowOne').html('');
            $('#modalServices .rowOne').html(data);
            $('#modalServices').modal('open');
        }
    });
    /*if($(this).attr('active') == 'no')
    {
        $('.sectionServices .element .info_'+this.id).css('top','0%','important');
        $(this).attr('active','si');
    }else{
        $('.sectionServices .element .info_'+this.id).css('top','100%','important');
        $(this).attr('active','no');
    }*/
});

$('.sectionPackages .element .btnOpen').click(function () {
    $('.sectionPackages .element .info_'+this.id).css('left','0%','important');
});

$('.sectionPackages .element .info .arrow').click(function () {
    $('.sectionPackages .element .info_'+this.id).css('left','-100%','important');
});

if ($(window).width() > 991) {
    $('.sectionAbout img').css('visibility', 'hidden');
    $('.sectionPlants img').css('visibility', 'hidden');
    $('.sectionInstagram .instragramImages').css('visibility', 'hidden');
}
$(window).scroll(function() {
    if ($(window).width() > 991) {
        $('.sectionAbout').waypoint(function (direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionAbout img').css('visibility', 'inherit');
                    $('.sectionAbout img').addClass('animated slideInLeft');
                }, 200);
            }
        }, {offset: '75%'});
        $('.sectionPlants').waypoint(function (direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionPlants img').css('visibility', 'inherit');
                    $('.sectionPlants img').addClass('animated slideInRight');
                }, 200);
            }
        }, {offset: '75%'});
        $('.sectionInstagram').waypoint(function (direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionInstagram .instragramImages').css('visibility', 'inherit');
                    $('.sectionInstagram .instragramImages').addClass('animated rotateInUpLeft');
                }, 200);
            }
        }, {offset: '75%'});
    }
});

$('.sectionServices .page').hide();
$('.sectionServices .showServices').click(function () {
    if(this.id == 'no')
    {
        $('.sectionServices .showServices').hide();
        swal({
            text: "No hay mas servicios",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    $('.sectionServices .page_'+this.id).show();
    if(this.id == validatePageServices)
    {
        $('.sectionServices .showServices').attr('id','no')
    }else{
        $('.sectionServices .showServices').attr('id',parseInt(this.id)+1);
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js